import React, { useState } from "react";
import LearningQuiz from "../LearningQuiz/LearningQuiz";
import { Modal } from "react-bootstrap";
import {
    callAlert,
    callAlertConfirm,
    downloadPdfFile,
    secondsToHms,
  } from "../../services/CommonService";
//   } from "../../services/CommonService";

function QuizModal(props) {
  const { show, setShow, quizData } = props;
  const [type, setType] = useState("step1");

  const outputDatafn = (d) => {
    if (d === "cancelQuiz") {
      setShow(false);
    }
  };

  const handleClose = () => {
    callAlertConfirm(
      "",
      "Are you sure you want to cancel quiz?",
      (result) => {
        if (result.isConfirmed) {
        //   setCurrentStatus("video");
          setShow(false);
        } else if (result.isDenied) {
          return false;
        }
      },
      false
    );
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      fullscreen={true}
      className="bg-quiz"
    >
      <Modal.Header closeButton className="modal-header-quiz">
        <Modal.Title>{quizData?.videoName} </Modal.Title>
      </Modal.Header>
      <Modal.Body className=" bg-quiz ">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <LearningQuiz
              type={type}
              setType={setType}
              quizData={quizData}
              outputData={outputDatafn}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default QuizModal;
